import React from 'react'
import Layout from '../../components/Layout'
import styled from 'styled-components'
import md from 'react-markings'
import { Tabs, Tab } from '../../components/Tabs'
import Obfuscate from 'react-obfuscate'
import PageTitle from '../../components/PageTitle'
import Image from '../../images/soi_large.jpg'
import moment from 'moment'

const now = new Date()

const convertDates = str => {
  return moment(str).format('MMM Do')
}

const addDays = (date, days) => {
  var result = new Date(date)
  result.setDate(result.getDate() + days)
  return result
}

export default () => (
  <Layout>
    <div style={{ display: 'none' }}>
      <PageTitle name="Student Opinions of Instruction" />
    </div>
    <img src={Image} alt="Student Opinions of Instruction" />
    <Tabs>
      <Tab title="FAQ" render={() => <TabOne />} />
      <Tab title="Background" render={() => <Background />} />
      <Tab title="Students" render={() => <Students />} />
      <Tab title="Faculty" render={() => <Faculty />} />
      <Tab title="Representatives" render={() => <Representatives />} />
      <Tab title="Reports" render={() => <Reports />} />
    </Tabs>
  </Layout>
)

const TabOne = () => (
  <div>
    <Blurb />
    <h2>Survey Dates</h2>
    <Cards>
      {soiDates.map((group, i) => (
        <Card
          //href="https://studentopinions.ua.edu/Blue/default.aspx"
          href="https://ua.evaluationkit.com"
          key={i}
          target="_blank"
          style={{
            color:
              now > addDays(group.open, -60) && now < addDays(group.closes, 15)
                ? '#900'
                : 'inherit',
            display:
              now > addDays(group.open, -180) && now < addDays(group.posted, 15)
                ? null
                : 'none',
          }}
        >
          <Title>{group.term}</Title>
          <ul>
            {group.open && <li>Opens: {convertDates(group.open)} at 7AM</li>}
            {group.close && (
              <li>Closes: {convertDates(group.close)} at 11:59PM</li>
            )}
            {group.swClose && (
              <li>
                Social Work Closes: {convertDates(group.swClose)} at 11:59PM
              </li>
            )}
            {group.posted && (
              <li>Posted: {convertDates(group.posted)} at 12:00AM</li>
            )}
            {group.detail && (
              <li>Courses: {(group.detail)}</li>
            )}
          </ul>
        </Card>
      ))}
    </Cards>
    <WhySOI />
  </div>
)

const Card = styled.a`
  background: #fff;
  cursor: pointer;
  border: 1px #ccc solid;
  border-radius: 3px;
  text-decoration: none;
  padding: 1.25em 1em;
  width: 300px;
  height: 290px;
  margin: 0 auto;
  &:hover {
    transform: scale(1.05);
    box-shadow: 0 0 30px rgba(0, 0, 0, 0.15);
  }
`
const Title = styled.h3`
  text-align: center;
`

const Cards = styled.div`
  margin-bottom: 2em;
  display: grid;
  grid-template-columns: repeat(auto-fit, minmax(300px, 1fr));
  grid-auto-flow: row dense;
  grid-gap: 30px 10px;
  grid-auto-rows: minmax(100px, auto);
`

const soiDates = [
  {
    term: 'Winter Interim 2025',
    open: '2025-01-02',
    close: '2025-01-06',
    posted: '2025-05-07',
  },
  // {
  //   term: 'Spring 2024',
  //   open: '2024-04-14',
  //   close: '2024-04-28',
  //   posted: '2024-05-08',
  // },
  {
    term: 'Interim 2025',
    open: '2025-05-17',
    close: '2025-05-23',
    posted: '2025-08-06',
  },
  {
    term: 'Summer I 2025',
    open: '2025-06-19',
    close: '2025-06-25',
    posted: '2025-08-06',
  },
  {
    term: 'Summer II 2025',
    open: '2025-07-24',
    close: '2025-07-30',
    posted: '2025-08-06',
  },
  {
    term: 'Fall 2025',
    open: '2025-11-16',
    close: '2025-12-07',
    posted: '2025-12-17',
  },
  {
    term: 'EMBA',
    open: '2025-11-16',
    close: '2025-12-07',
    posted: '2025-12-17',
    //detail: 'MGT, GBA, IBA, OM',
  },
  // {
  //   term: 'H-EMBA',
  //   open: '2023-03-26',
  //   close: '2023-04-08',
  //   posted: '2023-05-10',
  //   //detail: 'EC, OM516, GBA, OM506',
  // },
  {
    term: 'Spring',
    open: '2025-04-13',
    close: '2025-04-27',
    posted: '2025-05-07',
  },
  {
    term: 'Summer EMBA 2024',
    open: '2024-06-30',
    close: '2024-07-13',
    posted: '2024-08-07',
  }
]

const Background = () =>
  md`
    ## Background

    For several years, The University of Alabama had been considering making a transition from paper course evaluations disseminated in the classroom to an on-line (anytime, anywhere) course evaluation system. A task force was formed to review products available from third party vendors. Between fall 2008 and fall 2009 pilot tests were conducted with eXplorance Inc.’s Blue Evaluation. In spring 2010, all courses previously evaluated with the paper forms will be converted to fully online course evaluations.

    ### Reasons for the change

    UA wanted to apply the best technological solutions available to encourage student s to share their opinions of instruction. The paper forms created tremendous volumes of paper to be handled by the academic departments, all of which must be manually scanned (i.e. over 40,000 each semester in Arts & Sciences alone). Stray marks or punctured paper may render the submission invalid because the scanner cannot read it. Students must also complete the evaluation within a limited amount of time at the end of a class session which can lead to less thoughtful responses. Additionally, due to the manual nature of the paper forms, reports to faculty often take months to deliver, therefore faculty cannot act on feedback provided by students in a timely manner. The new online system eliminates paper and invalid submissions, provides students access to complete the evaluation anytime, anywhere enabling them to provide more thoughtful responses, and reports can be delivered to faculty within a matter of days instead of months.

    ### Pilot projects successful

    The fall 2008 pilot project involved over 5,500 students being invited to complete on-line evaluations in all fully online courses taught in Continuing Studies and 20 sections of Management 395 in the College of Commerce and Business Administration. In the fall 2008 pilot, participation rates of Continuing Studies students more than doubled as compared to the response in the past using a different on-line mechanism. For the CBA students, the response rate was the same as with paper forms distributed in the classroom – about 66 percent completed the evaluations. Reports were available for faculty and academic administrators within two weeks after the beginning of the following semester.

    The spring 2009 extended pilot involved over 16,000 students and over 550 instructors in 1200 sections. The overall response rate was 54%, which was positive in light of the rapid implementation and limited opportunity for communication. The spring 2009 extended pilot project dealt strictly with implementing the new on-line system, identifying any problems via the pilot groups and correcting them before the larger implementation for fall 2009. There are other aspects of student opinions of teaching that continue to be reviewed and discussed as well, but this project focused on improving the system of data collection.

    For the spring pilot, students participating received an invitation via their Bama email to complete the evaluations, then reminder emails were sent to those who had not responded. Additionally, students could have accessed the online course evaluation system through a link in MyBama (after login, they clicked on the Academics tab>>Banner Self Service>>Student Opinions of Teaching/Course Evaluation). They were prompted to login to the system using their MyBama username and password.

    Faculty and administrators received access to the final report(s) on June 19, 2009, later than anticipated due to the pilot. They received notification via their Bama email account and had also had the option to login through MyBama.

    Follow up surveys were conducted with both student and faculty participants to obtain feedback on the new system.

    During the fall 2009 survey period, several improvements were implemented based on lessons learned during the two pilot tests. Single sign on through myBama made the login and communication process more streamlined, especially for students. A theme was created to generate more awareness, “Your Opinion Matters!”, and was used on yard signs located in high traffic areas, on flyers and in myBama. Nine out of ten colleges fully participated in the online course evaluation process, eliminating the paper process altogether. The overall response rate was 52%.

    ### On-line approach encourages students to share their opinions of teaching

    Typically, when course evaluations transition from paper form to on-line form, participation rates can drop off as students are not provided forms directly in the classroom but are sent them electronically. Responses, however, tend to be more thoughtful as respondents may take more time filling them out on-line. E-mail reminders are critical to the response rate and were used effectively in both the fall 2008 and spring 2009 pilots at UA. In fall 2009, a more comprehensive communication plan was employed in an effort to raise awareness and response rates. The communication campaign will continue to be enhanced.

    ### Confidentiality a key feature of new system

    As with the paper-form system, confidentiality of responses is critical and is a key feature of the system. The data is compiled in such a way that no single response is tied to a particular student. The information is compiled and provided in summary to the faculty member and administrators.

    ### Content of the Student Opinions of Instruction forms

    A common set of University approved evaluative questions are provided for all courses. This consistency with the evaluation instrument allows for cross-comparisons within a college or campus wide as part of the reports generated. In addition to the campus wide common data collected, individual schools and colleges can add specific questions/information that would be helpful to their ongoing efforts to improve teaching and learning.

    ### Contacts

    The Office of Institutional Research and Assessment (OIRA) has been designated as the institutional administrators of the system beginning with the spring 2009 extended pilot. Dr. Ivon Foster, assistant to the provost, has coordinated the project for the Office for Academic Affairs. OIRA contacts include Executive Director Lorne Kuffel and Jon Acker, Coordinator for Student Assessment. For more information, email [SOI@ua.edu](mailto:SOI@ua.edu?subject=SOI%20Information).
  `
const Blurb = () =>
  md`
    ## About SOI

    SOI is an online course evaluation system, replacing the traditional paper course evaluation system. SOI allows students to confidentially rate their UA learning experience, encouraging feedback about their courses and instructors. Reports of survey results are provided to UA faculty and administrators after grades are submitted. Student ratings are very important in helping instructors improve their teaching and in helping the University evaluate courses and faculty.
  `

const Faculty = () =>
  md`
    ## Faculty

    ### How do students rate their UA learning experience?

    SOI online course evaluation surveys are available to students near the end of each semester, usually during the last two weeks of classes. Students receive an invitation email from Provost James Dalton with instructions at the beginning of each data collection cycle. Periodic reminders from Provost Dalton are sent until a student has completed all their surveys. Instructors can monitor response rates in all of their participating classes through the SOI website, as described below. Class reports are usually available to instructors the day after final grades are submitted.

    ### What actions should instructors take with each SOI data collection cycle?

    Early in the semester, check to see that all of your courses are set up correctly in Banner with instructor(s) and instruction type(s) properly listed. Courses are selected for inclusion in SOI based solely on the information in the Banner system.

    Classes must have an enrollment of at least five students for inclusion. Certain course Schedule Types are automatically excluded, such as Independent Study-Self Paced or Thesis/Dissertation. Surveys are conducted for all instructors listed for the class, so it is most important that instructors are correctly listed in Banner.

    During the data collection period, let your students know that you value their input. Monitor response rates during data collection and remind students about the surveys.

    [//]: #( ### Access
    Below is information on how to access the functions available to you on the SOI website)

    [//]: #( ### Course Verification
    Please find detailed information regarding the SOI status of your courses by using the following procedure. Courses are selected for inclusion in SOI based solely on the information in the Banner system.)

    [//]: # "- Log in to [myBama](http://mybama.ua.edu/) and select either the Faculty or Employee tab"
    [//]: # (- Click on the “OIRA Resources” channel.)
    [//]: # (- Under “Student Opinions of Instruction” select "Your Included courses for the Current Surveys.")
    [//]: # "You may also access the site by going to [OIRA Resources](https://oirax.ua.edu/secure/site/sso/CAS), and log in using your myBAMA credentials."

    [//]: #( ### Monitoring Response Rates
    Please find response rates for each of your classes during the data collection period by using the following procedure:)

    [//]: # "- Log in to [myBama](http://mybama.ua.edu/) and select either the Faculty or Employee tab"
    [//]: # (- Click on the **OIRA Resources** channel, as shown below.)
    [//]: # (- Under **Student Opinions of Instruction** select **Your Current Response Rates**)
    [//]: # '- You may access response rates by going to [OIRA Resources](https://oirax.ua.edu/secure/site/sso/CAS), and selecting "Response Rates by Project."'

    [//]: # '### Access to Reports
    All SOI survey reports will be available to you as soon as possible, usually a few days after course grades are due. You may access reports by going to [OIRA Resources](https://oirax.ua.edu/secure/site/sso/CAS), and selecting "View Available Reports."'

  `

const Students = () =>
  md`
    ## Students

    Students will be notified via email when a new evaluation period has begun. To reach SOI through myBama, go to the Student tab and select the ‘SOI Student Opinions of Instruction’ channel.

    During evaluation periods you will find a list of your courses on your Dashboard. To evaluate a course, simply click on the ‘select’ link. You may save your evaluation and return as many times as you need to complete your evaluation. The Dashboard will provide a status for each course (Not Completed, Completed and In Progress). You will receive email reminders until all courses have a status of ‘Completed’ or until the evaluation period has closed.

    ### A message to students from Provost James Dalton

    > Student feedback on their classes at The University of Alabama is extremely important. It is used by faculty to improve their courses and teaching methods, and by department chairs and college deans to assess teaching effectiveness.
    >
    > Without your responsible input, we cannot effectively assess and improve teaching performance and student learning. Please be honest, fair, and constructive as you complete your evaluations.
    >
    > Your opinions matter.
    >
    > Thank you,
    >
    > James Dalton, Ph.D. <br/>
    > Provost
  `

const WhySOI = () =>
  md`
    ### Why SOI?

    The new online system eliminates paper and invalid submissions, provides students with access to complete the evaluation anytime, anywhere, and allows reports to be delivered to faculty more quickly. UA began transitioning to this system between fall 2008 and spring 2010, after careful consideration.

    ### What About Privacy?

    Student confidentiality is a high priority, and is a key feature of the SOI system. The data is compiled in such a way that no single response is tied to a particular student. The information is compiled and provided in summary form to the faculty members and administrators.

    ### What’s Being Asked?

    A common set of University approved evaluative questions are provided for all courses. This consistency in the evaluation instrument allows for cross-comparisons within a college or campus wide as part of the reports generated. In addition to the campus-wide common data collected, the individual schools and colleges have specific questions that are helpful to their ongoing efforts to improve teaching and learning.
  `

  const Reports = () =>
  md`
    ### SOI Reports
    
    [Access your SOI reports](https://ua.evaluationkit.com/)

  `

const Representatives = () => (
  <div>
    <h3>Representatives</h3>
    <table>
      <thead>
        <tr>
          <th>College/School</th>
          <th>Representative</th>
          <th>Email</th>
        </tr>
      </thead>
      <tbody>
        <tr>
          <td>A&amp;S</td>
          <td>Albert Pionke</td>
          <td>
            <Obfuscate email="Apionke@ua.edu" />
          </td>
        </tr>
        <tr>
          <td>Air Force Studies</td>
          <td>LTC James Lambertsen</td>
          <td>
            <Obfuscate email="" />
          </td>
        </tr>
        <tr>
          <td>C&amp;BA</td>
          <td>Kay Palan</td>
          <td>
            <Obfuscate email="kay.palan@culverhouse.ua.edu" />
          </td>
        </tr>
        <tr>
          <td>CIS</td>
          <td>Jim Bailey</td>
          <td>
            <Obfuscate email="jtbailey@ua.edu" />
          </td>
        </tr>
        <tr>
          <td>CCHS</td>
          <td>Cecil Robinson</td>
          <td>
            <Obfuscate email="crobinso@ua.edu" />
          </td>
        </tr>
        <tr>
          <td>ED</td>
          <td>Joy Burnham</td>
          <td>
            <Obfuscate email="jburnham@ua.edu" />
          </td>
        </tr>
        <tr>
          <td>EG</td>
          <td>Mark Barkey</td>
          <td>
            <Obfuscate email="mbarkey@eng.ua.edu" />
          </td>
        </tr>
        <tr>
          <td>HC</td>
          <td>Cassander Smith</td>
          <td>
            <Obfuscate email="clsmith17@ua.edu" />
          </td>
        </tr>
        <tr>
          <td>HES</td>
          <td>Jeannine Lawrence</td>
          <td>
            <Obfuscate email="jlawrence@ches.ua.edu" />
          </td>
        </tr>
        <tr>
          <td>Military Sciences</td>
          <td>LTC James Horn</td>
          <td>
            <Obfuscate email="" />
          </td>
        </tr>
        <tr>
          <td>NU</td>
          <td>Sara Kaylor</td>
          <td>
            <Obfuscate email="skkaylor@ua.edu" />
          </td>
        </tr>
        <tr>
          <td>OTIDE</td>
          <td>Megan Courington Welborn</td>
          <td>
            <Obfuscate email="megan.welborn@ua.edu" />
          </td>
        </tr>
        <tr>
          <td>SW</td>
          <td>Dione King</td>
          <td>
            <Obfuscate email="DmKing7@ua.edu" />
          </td>
        </tr>
      </tbody>
    </table>
    * = interim
  </div>
)
